import actionTypes from '../action-types';

export const setSelectedLanguage = (selectedLanguage = '') => ({
  type: actionTypes.SET_SELECTED_LANGUAGE,
  selectedLanguage,
});



// WEBPACK FOOTER //
// ./src/modules/utils/actions/selected-language/selected-language.actions.js